import { lazy, Suspense } from "react";
import { RouteObject } from "../../helpers/tixxt-router";
import Loading from "../shared/Loading";

const PageEditPage = lazy(() => import("./PageEditPage"));

const pagesRoutes: RouteObject[] = [
  {
    path: "/groups/:groupSlug/pages/:pageSlug/edit",
    element: (
      <Suspense fallback={<Loading />}>
        <PageEditPage />
      </Suspense>
    ),
  },
  {
    path: "/pages/:pageSlug/edit",
    element: (
      <Suspense fallback={<Loading />}>
        <PageEditPage />
      </Suspense>
    ),
  },
];

export default pagesRoutes;
